(function () {
  var desktopQuery = window.matchMedia('(min-width: 768px)');

  function initSection(section) {
    if (!section || section.securityVideoShowcase) return;

    var rows = Array.prototype.slice.call(section.querySelectorAll('[data-svs-row]'));
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-svs-media]'));
    var mediaFrame = section.querySelector('[data-svs-media-frame]');
    var desktop = section.querySelector('.svs-desktop');
    var frameHeight = 520;
    var ticking = false;
    var sectionObserver = null;
    var mobileObserver = null;
    var resizeObserver = null;

    function hydrateVideo(video) {
      if (!video || video.dataset.loaded) return;

      Array.prototype.slice.call(video.querySelectorAll('source[data-src]')).forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.preload = 'auto';
      video.dataset.loaded = 'true';
      video.load();
    }

    function playVideo(video) {
      hydrateVideo(video);
      if (video.dataset.loaded) video.play().catch(function () {});
    }

    function hydrateInitialVideos() {
      var selector = desktopQuery.matches
        ? '.svs-media-item:first-child [data-svs-video]'
        : '.svs-mobile-card:first-child [data-svs-video]';
      Array.prototype.slice.call(section.querySelectorAll(selector)).forEach(function (video) {
        hydrateVideo(video);
        if (!desktopQuery.matches) playVideo(video);
      });
    }

    function initMobileVideos() {
      if (desktopQuery.matches) return;

      var videos = Array.prototype.slice.call(section.querySelectorAll('.svs-mobile-card:not(:first-child) [data-svs-video]'));
      if (!videos.length) return;

      if (!('IntersectionObserver' in window)) return;

      mobileObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          playVideo(entry.target);
          mobileObserver.unobserve(entry.target);
        });
      }, { threshold: 0.8 });

      videos.forEach(function (video) {
        mobileObserver.observe(video);
      });
    }

    function measure() {
      if (!desktop || !mediaFrame || !rows.length) return;

      frameHeight = mediaFrame.offsetHeight || 520;
      requestSync();
    }

    function setSlice(item, top, height) {
      item.style.top = top + 'px';
      item.style.height = height + 'px';
      item.classList.toggle('is-splitting', top > 0 && height > 1 && height < frameHeight - 1);
      item.classList.toggle('is-active', height > 0);

      Array.prototype.slice.call(item.querySelectorAll('video, img')).forEach(function (node) {
        node.style.top = -top + 'px';
      });

      Array.prototype.slice.call(item.querySelectorAll('video')).forEach(function (video) {
        if (height <= 0) {
          video.pause();
          return;
        }

        if (height >= frameHeight - 1) playVideo(video);
      });
    }

    function render() {
      if (!desktopQuery.matches || !mediaFrame || !rows.length) return;

      var frameRect = mediaFrame.getBoundingClientRect();
      var slices = [];
      var usedHeight = 0;

      rows.forEach(function (row, index) {
        var rowRect = row.getBoundingClientRect();
        var top = Math.max(frameRect.top, rowRect.top);
        var bottom = Math.min(frameRect.bottom, rowRect.bottom);
        var height = Math.max(0, Math.round(bottom - top));
        var sliceTop = Math.max(0, Math.round(top - frameRect.top));
        slices[index] = { top: sliceTop, height: height };
        usedHeight += height;
      });

      if (usedHeight === 0) {
        var firstRowRect = rows[0].getBoundingClientRect();
        slices[frameRect.top < firstRowRect.top ? 0 : rows.length - 1] = { top: 0, height: frameHeight };
      } else if (usedHeight < frameHeight) {
        var largest = 0;
        slices.forEach(function (slice, index) {
          if (slice && slice.height > ((slices[largest] && slices[largest].height) || 0)) largest = index;
        });
        if (slices[largest]) slices[largest].height += frameHeight - usedHeight;
      }

      items.forEach(function (item, index) {
        setSlice(item, (slices[index] || { top: 0 }).top, (slices[index] || { height: 0 }).height);
      });
    }

    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        render();
      });
    }

    function onResize() {
      measure();
    }

    if ('IntersectionObserver' in window) {
      sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hydrateInitialVideos();
          sectionObserver.disconnect();
        });
      }, { rootMargin: '1800px 0px' });
      sectionObserver.observe(section);
    } else {
      hydrateInitialVideos();
    }

    initMobileVideos();

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', onResize);

    if ('ResizeObserver' in window && desktop) {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(desktop);
      rows.forEach(function (row) {
        resizeObserver.observe(row);
      });
    }

    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure).catch(function () {});

    section.securityVideoShowcase = {
      destroy: function () {
        window.removeEventListener('scroll', requestSync);
        window.removeEventListener('resize', onResize);
        if (sectionObserver) sectionObserver.disconnect();
        if (mobileObserver) mobileObserver.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        section.securityVideoShowcase = null;
      }
    };
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-security-video-showcase]')).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target.matches('[data-security-video-showcase]')
      ? event.target
      : event.target.querySelector('[data-security-video-showcase]'));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches('[data-security-video-showcase]')
      ? event.target
      : event.target.querySelector('[data-security-video-showcase]');
    if (section && section.securityVideoShowcase && section.securityVideoShowcase.destroy) {
      section.securityVideoShowcase.destroy();
    }
  });
})();
